import React from "react";
import { Button } from "components/generic/kit";
import { Input, Formik } from "components/generic/form/formik";
import { Title, Row, Label, ErrorBox } from "components/generic/form/service";
import { NarrowBody } from "components/generic/layout";
import { UnsignedLayout } from "components/common/auth";

export default ({ validationSchema, onSubmit, setPasswordApi, errors }) => (
  <UnsignedLayout>
    <NarrowBody>
      <Formik
        initialValues={{
          new_password: "",
          repeat_password: ""
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        errors={errors.field}
      >
        {props => (
          <div>
            {!!errors.nonField.length && <ErrorBox errors={errors.nonField} />}
            <Title>Setting new password</Title>
            <form onSubmit={props.handleSubmit}>
              <Row>
                <Label title="New password">
                  <Input
                    name="new_password"
                    placeholder="New password"
                    type="password"
                  />
                </Label>
              </Row>
              <Row>
                <Label title="Repeat password">
                  <Input
                    name="repeat_password"
                    placeholder="Repeat new password"
                    type="password"
                  />
                </Label>
              </Row>

              <div className="w-100 mt3">
                <Button type="submit" disabled={setPasswordApi.isFetching}>
                  Submit
                </Button>
              </div>
            </form>
          </div>
        )}
      </Formik>
    </NarrowBody>
  </UnsignedLayout>
);



// WEBPACK FOOTER //
// ./src/components/pages/Auth/SetPass/View.js